import React, { Component } from 'react';
import PubSub from 'pubsub-js'
import { meshLog, SPGet } from "../../../utils/spUtils";
import { TimePicker, Button } from 'antd';
import dayjs from 'dayjs';
import './setEmergencyDialog.less';
import close_btn from '../../../imgs/btn/close_btn.png';
import emer_time from "../../../imgs/item/emer_time.png";
import emer_week from "../../../imgs/item/emer_week.png";
import repeat from "../../../imgs/item/repeat.png";
import { SET_Emergency_DIALOG_SHOW,SET_Emergency_DIALOG_HIDE } from '../../../const/infoConst';
import { editEmergencyTime } from '../../../utils/scheduleUtils';
import { transIntTo2Str } from '../../../utils/dataUtils';

let t_h = 10;
let t_m = 0; 

//设备设置界面
export default class SetEmergencyDialog extends Component {
    constructor(a) {
        super(a);
        this.state = {
            time_text:"10:00",
            time_hide:false,
            w_mon: 1,
            w_tues: 0,
            w_weds: 0,
            w_thurs: 0,
            w_fri: 0,
            w_sat: 0,
            w_sun: 0,
            w_week1: 1,
            w_week2: 0,
            w_week3: 0,
            w_week4: 0,
        }
    }

    componentDidMount() {
        PubSub.subscribe(SET_Emergency_DIALOG_SHOW, (msg, index) => {
            this.updateScheduleUI();
        })
    }

    //更新应急电源日程UI
    updateScheduleUI(){
        //数据初始化,每次打开都是新日程
        this.setState({
            time_text:"10:00",
            time_hide:false,
            w_mon: 1,
            w_tues: 0,
            w_weds: 0,
            w_thurs: 0,
            w_fri: 0,
            w_sat: 0,
            w_sun: 0,
            w_week1: 1,
            w_week2: 0,
            w_week3: 0,
            w_week4: 0,
        });
    }

    // 弹窗关闭
    closeBtnClick = async () => {
        meshLog("closeBtnClick");
        PubSub.publish(SET_Emergency_DIALOG_HIDE, '');
    }

    saveBtnClick = async () => {
        meshLog("saveBtnClick");
        const { w_mon, w_tues, w_weds, w_thurs, w_fri, w_sat, w_sun, w_week1, w_week2, w_week3, w_week4} = this.state;
        let time=parseInt(t_h) * 60 + parseInt(t_m);
        let week=w_mon*1 + w_tues*2 + w_weds*4 + w_thurs*8 + w_fri*16 + w_sat*32 + w_sun*64;
        let repet = w_week1 * 1 + w_week2 * 2 + w_week3 * 3 + w_week4 * 4;
        editEmergencyTime(time,week,repet);
    }

    // Time
    handleTimeChange = (time, timeString) => {
        meshLog("wjk onTimeChange");
        const arr = timeString.split(':');
        t_h=arr[0];
        t_m=arr[1];
        console.log(time, timeString,t_h,t_m);
        this.setState({ 
            // time_info:moment(t_h+":"+transIntTo2Str(t_m), "HH:mm"),
            time_text:t_h+":"+transIntTo2Str(t_m),
        });
    };
    handleOnFocus= () => {
        this.setState({ 
            time_hide:true,
        });
    }
    handleOnBlur= () => {
        this.setState({ 
            time_hide:false,
        });
    }

    // 星期选择
    week1BtnClick = () => {
        this.setState({
            w_mon: 1,
            w_tues: 0,
            w_weds: 0,
            w_thurs: 0,
            w_fri: 0,
            w_sat: 0,
            w_sun: 0,
        });
    }
    week2BtnClick = () => {
        this.setState({
            w_mon: 0,
            w_tues: 1,
            w_weds: 0,
            w_thurs: 0,
            w_fri: 0,
            w_sat: 0,
            w_sun: 0,
        });
    }
    week3BtnClick = () => {
        this.setState({
            w_mon: 0,
            w_tues: 0,
            w_weds: 1,
            w_thurs: 0,
            w_fri: 0,
            w_sat: 0,
            w_sun: 0,
        });
    }
    week4BtnClick = () => {
        this.setState({
            w_mon: 0,
            w_tues: 0,
            w_weds: 0,
            w_thurs: 1,
            w_fri: 0,
            w_sat: 0,
            w_sun: 0,
        });
    }
    week5BtnClick = () => {
        this.setState({
            w_mon: 0,
            w_tues: 0,
            w_weds: 0,
            w_thurs: 0,
            w_fri: 1,
            w_sat: 0,
            w_sun: 0,
        });
    }
    week6BtnClick = () => {
        this.setState({
            w_mon: 0,
            w_tues: 0,
            w_weds: 0,
            w_thurs: 0,
            w_fri: 0,
            w_sat: 1,
            w_sun: 0,
        });
    }
    week7BtnClick = () => {
        this.setState({
            w_mon: 0,
            w_tues: 0,
            w_weds: 0,
            w_thurs: 0,
            w_fri: 0,
            w_sat: 0,
            w_sun: 1,
        });
    }
    weeks1BtnClick = () => {
        this.setState({
            w_week1: 1,
            w_week2: 0,
            w_week3: 0,
            w_week4: 0,
        });
    }
    weeks2BtnClick = () => {
        this.setState({
            w_week1: 0,
            w_week2: 1,
            w_week3: 0,
            w_week4: 0,
        });
    }
    weeks3BtnClick = () => {
        this.setState({
            w_week1: 0,
            w_week2: 0,
            w_week3: 1,
            w_week4: 0,
        });
    }
    weeks4BtnClick = () => {
        this.setState({
            w_week1: 0,
            w_week2: 0,
            w_week3: 0,
            w_week4: 1,
        });
    }


    render() {
        const {time_text,time_hide, w_mon, w_tues, w_weds, w_thurs, w_fri, w_sat, w_sun, w_week1, w_week2, w_week3, w_week4 } = this.state;
        return (
            <div className="emergency_container">
                <div className="ui_grey_bg" />
                <div className="emergency_dialog" style={{ left: (document.body.clientWidth - 500) / 2 }}>
                    {/* 标题 */}
                    <span className='emergency_title'>Schedule Management</span>
                    <img className='emergency_closeBtn' src={close_btn} onClick={() => { this.closeBtnClick() }} />
                    {/* 时间 */}
                    <div className="emergency_item1">
                        <img className='icon' src={emer_time} />
                        <span>Start Time</span>
                    </div>
                    <div className='emergency_timeBg'>
                        <span className='time_text'>{time_hide?"":time_text}</span>
                        <TimePicker
                            className='timepicker'
                            defaultValue={dayjs('10:00', 'HH:mm')} format={'HH:mm'}
                            // value={time_info}   
                            needConfirm={true}
                            showNow={false}
                            allowClear={false}
                            inputReadOnly={true}
                            onFocus={this.handleOnFocus}
                            onBlur={this.handleOnBlur}
                            onChange={this.handleTimeChange}/>
                    </div>
                    {/* 单独星期 */}
                    <div className="emergency_item2">
                        <img className='icon' src={emer_week} />
                        <span>Schedule Date</span>
                    </div>
                    <div className='emergency_weekBg'>
                        <div className='emergency_weekSelect'>
                            <div className='weekBtn1' style={{ background: w_mon == 1 ? "#fbc800" : "#fff" }} onClick={() => { this.week1BtnClick() }}><span>Mon</span></div>
                            <div className='weekBtn2' style={{ background: w_tues == 1 ? "#fbc800" : "#fff" }} onClick={() => { this.week2BtnClick() }}><span>Tues</span></div>
                            <div className='weekBtn3' style={{ background: w_weds == 1 ? "#fbc800" : "#fff" }} onClick={() => { this.week3BtnClick() }}><span>Weds</span></div>
                            <div className='weekBtn4' style={{ background: w_thurs == 1 ? "#fbc800" : "#fff" }} onClick={() => { this.week4BtnClick() }}><span>Thurs</span></div>
                            <div className='weekBtn5' style={{ background: w_fri == 1 ? "#fbc800" : "#fff" }} onClick={() => { this.week5BtnClick() }}><span>Fri</span></div>
                            <div className='weekBtn6' style={{ background: w_sat == 1 ? "#fbc800" : "#fff" }} onClick={() => { this.week6BtnClick() }}><span>Sat</span></div>
                            <div className='weekBtn7' style={{ background: w_sun == 1 ? "#fbc800" : "#fff" }} onClick={() => { this.week7BtnClick() }}><span>Sun</span></div>
                        </div>
                    </div>
                    {/* 循环星期 */}
                    <div className="emergency_item3">
                        <img className='icon' src={repeat} />
                        <span>Repeat</span>
                    </div>
                    <div className='emergency_weeks'>
                        <div className='weeksSelect'>
                            <div className='weeksBtn1' style={{ background: w_week1 == 1 ? "#fbc800" : "#fff" }} onClick={() => { this.weeks1BtnClick() }}><span>1week</span></div>
                            <div className='weeksBtn2' style={{ background: w_week2 == 1 ? "#fbc800" : "#fff" }} onClick={() => { this.weeks2BtnClick() }}><span>2week</span></div>
                            <div className='weeksBtn3' style={{ background: w_week3 == 1 ? "#fbc800" : "#fff" }} onClick={() => { this.weeks3BtnClick() }}><span>3week</span></div>
                            <div className='weeksBtn4' style={{ background: w_week4 == 1 ? "#fbc800" : "#fff" }} onClick={() => { this.weeks4BtnClick() }}><span>4week</span></div>
                        </div>
                    </div>

                    {/* 底部按钮 */}
                    <div className="emergency_footer">
                        <button className='cancelBtn' onClick={() => { this.closeBtnClick() }}>Cancel</button>
                        <button className='okBtn' onClick={() => { this.saveBtnClick() }}>Confirm</button>
                    </div>


                </div>
            </div>
        );

    }
};
